import React, { useEffect, useState } from 'react';

const SettingsPage: React.FC = () => {
  const [emailAlerts, setEmailAlerts] = useState(false);
  const [compactView, setCompactView] = useState(false);

  useEffect(() => {
    const storedAlerts = localStorage.getItem('settings.emailAlerts');
    const storedCompactView = localStorage.getItem('settings.compactView');
    setEmailAlerts(storedAlerts === 'true');
    setCompactView(storedCompactView === 'true');
  }, []);

  const onToggleAlerts = () => {
    setEmailAlerts((prev) => {
      const next = !prev;
      localStorage.setItem('settings.emailAlerts', String(next));
      return next;
    });
  };

  const onToggleCompactView = () => {
    setCompactView((prev) => {
      const next = !prev;
      localStorage.setItem('settings.compactView', String(next));
      return next;
    });
  };

  return (
    <section className="feature-page settings-page">
      <div className="panel settings-panel">
        <h1>Settings</h1>
        <p>Manage how your account experience works across profile and history views.</p>

        <div className="settings-options">
          <div className="settings-item">
            <div>
              <h3>Email Alerts</h3>
              <p>Get updates when new biodiversity prediction features are available.</p>
            </div>
            <button type="button" className={`settings-toggle ${emailAlerts ? 'active' : ''}`} onClick={onToggleAlerts}>
              {emailAlerts ? 'On' : 'Off'}
            </button>
          </div>

          <div className="settings-item">
            <div>
              <h3>Compact History Cards</h3>
              <p>Use tighter spacing in profile history cards.</p>
            </div>
            <button type="button" className={`settings-toggle ${compactView ? 'active' : ''}`} onClick={onToggleCompactView}>
              {compactView ? 'On' : 'Off'}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SettingsPage;
